import { Form, Select } from "antd";
import React from "react";

const MultipleEmails = () => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return (
    <>
      <Form.Item
        label="Contact emails"
        name="contact_emails"
        extra="Please input email and hit enter to add"
        rules={[
          {
            validator(_, value) {
              if (!value || value.every((email) => emailRegex.test(email))) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("Please input valid email address")
              );
            },
          },
        ]}
      >
        <Select
          mode="tags"
          style={{
            width: "100%",
          }}
          tokenSeparators={[","]}
          placeholder="Please input email and hit enter to add"
        />
      </Form.Item>
    </>
  );
};

export default MultipleEmails;
